module.exports = __webpack_public_path__ + "static/img/homeBanner_m.b916de0c.png";